<template>
    <div
        v-if="showButton"
        class="flex flex-wrap mt-4 gap-1.5"
    >
        <NuxtLink
            v-for="(file) in item.files.data"
            :key="file.id"
            :href="file.url"
            target="_blank"
            class="item-file flex items-center rounded-md"
            data-test="timeline-item-file"
        >
            <icon-file-download class="mr-1.5" />
            <span class="item-file-name">{{ truncateLabelWithSuffix(file.name, 26) }}</span>
        </NuxtLink>
    </div>
</template>

<script setup lang="ts">
    import IconFileDownload from '~/components/icons/IconFileDownload.vue';
    import type { ITimelineItem } from '~/types/types';
    import { type PropType, computed } from 'vue';
    import { useAccountStore } from '~/stores/accountStore';
    import { truncateLabelWithSuffix } from '~/utils/helpers';

    const props = defineProps({
        item: {
            type: Object as PropType<ITimelineItem>,
            required: false,
            default: () => {},
        },
    });

    const { buttonColor, buttonTextColor } = useAccountStore().state;

    const showButton = computed(() => {
        return props.item.files.data.length > 0;
    });
</script>

<style lang="scss">
    $buttonColor: v-bind(buttonColor);
    $buttonTextColor: v-bind(buttonTextColor);

    .item-file {
        background-color: #f7f7f7;
        color: #222;
        padding: 0.35rem 0.7rem;
        transition: all 0.15s ease;
        text-decoration: none !important;

        &:hover {
            filter: none !important;
            background-color: #eee;

            svg {
                color: #222;
            }
        }

        svg {
            color: #888;
            width: 14px;
            transition: all 0.15s ease;
        }
    }

    .item-file-name {
        font-size: 0.75rem;
        line-height: 1rem;
        color: #222;
    }
</style>
